module.exports = __webpack_public_path__ + "img/noData.139c52f7.png";